(function () {

  function formatMoney(cents) {
  var format = (window.theme && window.theme.moneyFormat) || '€{{amount}}';
  var placeholder = /\{\{\s*(\w+)\s*\}\}/;
  var match = format.match(placeholder);
  if (match) {
    var value = formatWithDelimiters(cents, match[1]);
    return format.replace(placeholder, value);
  }
  return format;

  function formatWithDelimiters(cents, name) {
    var number = parseFloat(cents) / 100;
    if (isNaN(number)) return '';

    // precision, thousands separator, decimal separator per placeholder name
    var precision = 2, thousands = ',', decimal = '.';
    switch (name) {
      case 'amount':                                 precision = 2; thousands = ','; decimal = '.'; break;
      case 'amount_no_decimals':                     precision = 0; thousands = ','; decimal = '.'; break;
      case 'amount_with_comma_separator':            precision = 2; thousands = '.'; decimal = ','; break;
      case 'amount_no_decimals_with_comma_separator':precision = 0; thousands = '.'; decimal = ','; break;
      case 'amount_with_apostrophe_separator':       precision = 2; thousands = "'"; decimal = '.'; break;
      case 'amount_with_space_separator':            precision = 2; thousands = ' '; decimal = ','; break;
      case 'amount_no_decimals_with_space_separator':precision = 0; thousands = ' '; decimal = ''; break;
    }

    var parts = number.toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var frac = parts[1] ? decimal + parts[1] : '';
    return whole + frac;
  }
}

  document.querySelectorAll('.yp').forEach(function (root) {
    var sectionId = root.id.replace('yp-', '');

    var dataEl = document.getElementById('yp-data-' + sectionId);
    var variants = [];
    if (dataEl) {
      try { variants = (JSON.parse(dataEl.textContent) || {}).variants || []; } catch (e) { variants = []; }
    }

    var mainImg      = document.getElementById('yp-main-img-' + sectionId);
    var priceEl      = document.getElementById('yp-price-' + sectionId);
    var compareEl    = document.getElementById('yp-price-compare-' + sectionId);
    var variantInput = document.getElementById('yp-variant-id-' + sectionId);
    var atcBtn       = document.getElementById('yp-atc-' + sectionId);
    var atcText      = atcBtn ? atcBtn.querySelector('.yp-atc__text') : null;
    // Declared here (rather than only in the "quantity stepper" block below)
    // so updateVariant() can toggle their disabled state on variant switch.
    var qtyInput = document.getElementById('yp-qty-input-' + sectionId);
    var qtyMinus = document.getElementById('yp-qty-minus-' + sectionId);
    var qtyPlus  = document.getElementById('yp-qty-plus-' + sectionId);

    /* ── THUMBNAILS ── */
    root.querySelectorAll('.yp-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('.yp-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.src = thumb.getAttribute('data-full');
        }
      });
    });

    /* ── QUANTITY STEPPER ──
       qtyInput is type="text" (see liquid comment for why — mobile
       input[type=number] repaint bug), so unlike a native number input we
       get no built-in min/validation. Enforce it ourselves here, and also
       sanitize free-typed input since a text field accepts anything.

       setQtyValue() below is deliberately more defensive than a plain
       `qtyInput.value = v` assignment. Live debugging on a real phone
       (DevTools console, not just this automated environment) showed the
       DOM value genuinely updating on every check — correct value,
       correct color, correct size, topmost/unoccluded element, listener
       confirmed attached via getEventListeners() — yet nothing visibly
       changed on screen after tapping + or -. That combination only makes
       sense as a paint/repaint bug: some mobile engines don't reliably
       repaint a form control's displayed text when only the JS `.value`
       property is set (as opposed to the user typing), especially with
       custom appearance/border/background overrides like ours. Setting
       the `value` ATTRIBUTE too, forcing a synchronous reflow, and
       dispatching a real `input` event covers the known ways to force a
       repaint in that scenario. This is defensive, not exploratory — if
       the repaint bug isn't happening on a given device, this is a no-op.
    */
    function setQtyValue(v) {
      if (!qtyInput) return;
      qtyInput.value = v;
      qtyInput.setAttribute('value', v);
      void qtyInput.offsetHeight; // force sync reflow
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) setQtyValue(v - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        setQtyValue(v + 1);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        var digitsOnly = qtyInput.value.replace(/[^0-9]/g, '');
        if (digitsOnly !== qtyInput.value) qtyInput.value = digitsOnly;
      });
      qtyInput.addEventListener('blur', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        setQtyValue(v < 1 ? 1 : v);
      });
    }

    /* ── ADD TO BAG ──
       Palo Alto's native ProductForm class (theme.js — core, unmodifiable)
       determines the submitted quantity via a descendant-only DOM query it
       caches once when it constructs itself. For reasons we couldn't pin
       down in the minified bundle, it never recognizes our quantity input,
       so the native flow always adds quantity 1 no matter what the stepper
       shows — confirmed by reading theme.js directly and testing live.

       First attempt intercepted the form's `submit` event, on the theory
       that Palo Alto hooked submission. Live testing proved that wrong:
       clicking Add to Bag never fires a `submit` event at all (confirmed
       by attaching a throwaway document-level capture listener and
       checking it never ran) — Palo Alto binds its own `click` handler
       directly on the button and calls preventDefault()+its own AJAX
       add-to-cart logic before the browser ever gets to dispatch `submit`.

       So instead we intercept the `click` in the capture phase on
       `document`. Capture-phase listeners on an ancestor always run before
       the event reaches the target, so stopping propagation here keeps
       Palo Alto's own click handler (bound on the button itself) from ever
       firing. We POST straight to Shopify's own /cart/add.js with the
       quantity we know is correct.

       Refreshing the drawer: our first version dispatched a synthetic
       click on the drawer's own toggle link, assuming Palo Alto's
       CartDrawer class would re-fetch fresh cart contents whenever it
       opens. It doesn't. The drawer's markup lives in a dormant
       <template data-cart-drawer-template> that Palo Alto only re-renders
       when ITS OWN addToCart()/getCart() flow runs — since we bypass that
       flow entirely (for the correct-quantity fix above), the template
       stayed frozen at whatever the cart looked like on page load, so the
       drawer opened showing stale/empty contents until a full page
       reload. Confirmed by reading theme.js: `window.cart` is a live,
       globally-exposed instance of Palo Alto's CartDrawer class
       (`window.cart = new CartDrawer` in theme.js), with public
       `getCart()` (re-fetches /cart.js + the cart-items section and
       re-renders the drawer's contents/badges) and `openCartDrawer()`
       (just toggles the visible/open state) methods. Calling those
       ourselves after our own successful add is the correct, native way
       to bring the drawer's dormant template back in sync — far more
       reliable than us hand-rolling our own HTML fetch/replace of
       Palo Alto's internal markup. Falls back to the old synthetic-click
       toggle only if `window.cart` isn't present for some reason.
    */
    if (atcBtn) {
      document.addEventListener('click', function (e) {
        if (!atcBtn.contains(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (atcBtn.disabled) return;

        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var variantId = variantInput ? variantInput.value : atcBtn.getAttribute('data-product-id');
        var originalText = atcText ? atcText.textContent : '';

        atcBtn.disabled = true;
        if (atcText) atcText.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
          .then(function (res) {
            if (!res.ok) { return res.json().then(function (err) { throw err; }); }
            return res.json();
          })
          .then(function () {
            if (window.cart && typeof window.cart.getCart === 'function') {
              // The checkout button's total staying stale after this call
              // (Palo Alto renders it twice in the drawer and only updates
              // one copy) is patched globally in assets/yaoskin-cart-fix.js,
              // not here — that bug isn't specific to this Add to Bag flow,
              // the drawer's own native +/- buttons trigger it too, so it's
              // handled once for every cart-changing control site-wide.
              window.cart.getCart();
              if (typeof window.cart.openCartDrawer === 'function') {
                window.cart.openCartDrawer();
              }
            } else {
              var cartToggle = document.querySelector('[data-cart-drawer-toggle]');
              if (cartToggle) {
                cartToggle.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
              }
            }
          })
          .catch(function (err) {
            window.alert((err && err.description) || 'Could not add this item to your bag. Please try again.');
          })
          .then(function () {
            atcBtn.disabled = false;
            if (atcText) atcText.textContent = originalText;
          });
      }, true);
    }

    /* ── ACCORDIONS ── */
    root.querySelectorAll('.yp-acc-header').forEach(function (header) {
      header.addEventListener('click', function () {
        var body = header.nextElementSibling;
        var isOpen = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (body) body.style.display = isOpen ? 'none' : 'block';
        var icon = header.querySelector('.yp-acc-icon');
        if (icon) icon.textContent = isOpen ? '+' : '−';
      });
    });

    /* ── VARIANT / OPTION PICKER ── */
    if (variants.length) {
      var selected = {};
      root.querySelectorAll('.yp-option-pill.active').forEach(function (p) {
        selected[p.getAttribute('data-position')] = p.getAttribute('data-value');
      });

      var findVariant = function () {
        var positions = Object.keys(selected).sort(function (a, b) { return a - b; });
        return variants.filter(function (v) {
          return positions.every(function (pos, idx) {
            return v.options[idx] === selected[pos];
          });
        })[0];
      };

      var updateVariant = function () {
        var variant = findVariant();
        if (!variant) return;

        if (variantInput) variantInput.value = variant.id;

        if (priceEl) priceEl.innerHTML = formatMoney(variant.price);

        if (compareEl) {
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          if (onSale) {
            compareEl.innerHTML = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        if (mainImg && variant.featured_image) {
          mainImg.removeAttribute('srcset');
          mainImg.src = variant.featured_image;
        }

        const inventoryElement = root.querySelector('[data-product-inventory]');
        const inventoryMap = inventoryElement
          ? JSON.parse(inventoryElement.textContent)
          : {};

        const inventoryQuantity = Number(
          inventoryMap[String(variant.id)] ?? 0
        );

        const onlineInventoryThreshold = Number(
          atcBtn?.dataset.onlineInventoryThreshold ||
          window.YaoSkinInventory?.threshold ||
          0
        );

        const onlineAvailable =
          variant.available &&
          inventoryQuantity >= onlineInventoryThreshold;

        if (atcBtn) {
          atcBtn.disabled = !onlineAvailable;
        }

        if (atcText) {
          atcText.textContent = onlineAvailable ? 'Add to Bag' : 'Sold Out';
        }

        // Keep the quantity stepper consistent with the Add to Bag state
        // no point letting shoppers dial in a quantity for something sold out.
        if (qtyInput) qtyInput.disabled = !onlineAvailable;
        if (qtyMinus) qtyMinus.disabled = !onlineAvailable;
        if (qtyPlus) qtyPlus.disabled = !onlineAvailable;
      };

      root.querySelectorAll('.yp-option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var position = pill.getAttribute('data-position');
          var group = pill.closest('.yp-option-pills');
          if (group) {
            group.querySelectorAll('.yp-option-pill').forEach(function (p) { p.classList.remove('active'); });
          }
          pill.classList.add('active');
          selected[position] = pill.getAttribute('data-value');
          updateVariant();
        });
      });
    }

  });

})();
